import {laBolsaHoyTickerPremiumNews} from "../modulos/laBolsaHoy/laBolsaHoy";
import {streamingConnector} from "../modulos/quotes/streamingConnector";
import {loadHighCharts} from "../modulos/highchart/highchart";
import fullscreen from "../utils/fullscreen";
import {tippy} from '../modulos/tippy/tippy';
import {loadForos} from "../modulos/foros/foros";

import {commonQuotesAndStockDetail} from "./index-quotes";
import {premiumFaStock} from "../modulos/quotes/premiumFa";
import {premiumMT} from "../modulos/quotes/premiumMaquinaTrading";
import {drawHighChartScore, fetchSeries} from "../modulos/indicators/indicators";

import './css/index-stock-detail.scss';
import '../modulos/indicators/scss/indicatorGeneral.scss';
import '../modulos/indicators/scss/indicatorsElement.scss';

const indicadores = () => {
    var loadedIndicators = false;
    var $indicatorBtn = $('#indicatorTabBtn');
    var $indicatorSelector = $('#pane-4_tbl_quotation');
    $indicatorBtn.on('click', function (e) {
        if (loadedIndicators) return;
        loadedIndicators = true;
        var url = $(this).data('url') || '/';
        var id = $(this).data('ticker');
        $.ajax({
            url: url + 'cotizaciones-indicadores' + '/' + id,
            cache: false,
            error: function (xhr, status) {
                console.error(xhr, status);
                var response = xhr.responseText || '<p>No se pudo obtener la información';
                $indicatorSelector.html(response);
            },
            success: function (response) {
                $indicatorSelector.html(response);
                const graphEl = document.querySelector('.indiGraph');
                fetchSeries(graphEl.dataset.url)
                    .then(data => drawHighChartScore({HighChart: window.Highcharts, data, el: graphEl}))
                    .catch(err => {
                        console.error(err);
                        graphEl.textContent = 'No se pudo mostrar el gráfico del indicador';
                    });
            }
        });
    });
}

const maquinaTrading = () => {
    var loadedTradingMachine = false;
    var $tradingMachineTabBtn = $('#tradingMachineTabBtn');
    var $tradingMachineSelector = $('#pane-6_tbl_quotation');
    $tradingMachineTabBtn.on('click', function (e) {
        if (loadedTradingMachine) return;
        loadedTradingMachine = true;
        var url = $(this).data('url') || '/';
        var id = $(this).data('ticker');
        $.ajax({
            url: url + 'cotizaciones-maquina-trading' + '/' + id,
            cache: false,
            error: function (x) {
                var response = x.responseText || '<p>No se pudo obtener la información';
                $tradingMachineSelector.html(response);
            },
            success: function (response) {
                $tradingMachineSelector.html(response);
            }
        });
    });
}

export const loadStockDetail = async () => {
    console.log('Loading StockDetail components');
    //Inicializa HighCharts
    loadHighCharts().then((Highcharts) => {
        //Módulos de la ficha
        indicadores();
        maquinaTrading();
    });

    //Solicita el semáforo de Análisis fundamental y Máquina de trading
    premiumFaStock();
    premiumMT();

    //Funciones comunes entre listados y páginas de cotización
    commonQuotesAndStockDetail();

    //Polyfill fullscreen
    fullscreen();

    //Cargar comentarios
    loadForos();

    //Conectar el HTML con el Streaming
    streamingConnector();

    //Tippy. Herramienta para tooltips de conceptos en indicadores clásicos y AF
    tippy();

    //Artículos de La Bolsa Hoy ofuscados para no premium
    (function () {
        laBolsaHoyTickerPremiumNews();
    })();
};
